import { FormEvent } from "react";
import { TranslationKey } from "../../../shared/i18n/i18n";
import { TurnstileWidget } from "./TurnstileWidget";

type ForgotPasswordRequestViewProps = {
  email: string;
  isSubmitting: boolean;
  onBackToSignIn: () => void;
  onEmailChange: (value: string) => void;
  onSubmit: (event: FormEvent) => Promise<void>;
  onTurnstileTokenChange: (value: string) => void;
  t: (key: TranslationKey) => string;
  turnstileResetKey: number;
  turnstileSiteKey: string;
  turnstileToken: string;
};

export const ForgotPasswordRequestView = ({
  email,
  isSubmitting,
  onBackToSignIn,
  onEmailChange,
  onSubmit,
  onTurnstileTokenChange,
  t,
  turnstileResetKey,
  turnstileSiteKey,
  turnstileToken,
}: ForgotPasswordRequestViewProps) => {
  return (
    <div className="forgot-layout">
      <form
        autoComplete="off"
        className="auth-form"
        onSubmit={(event) => void onSubmit(event)}
      >
        <label className="field">
          <span>{t("admin.field.email")}</span>
          <input
            onChange={(event) => onEmailChange(event.target.value)}
            required
            type="email"
            value={email}
          />
        </label>
        <TurnstileWidget
          onTokenChange={onTurnstileTokenChange}
          resetKey={turnstileResetKey}
          siteKey={turnstileSiteKey}
          token={turnstileToken}
        />
        <button
          className="primary-button"
          disabled={isSubmitting}
          type="submit"
        >
          {isSubmitting ? t("admin.button.requesting") : t("admin.button.requestReset")}
        </button>
      </form>
      <button
        className="link-button inline-link"
        onClick={onBackToSignIn}
        type="button"
      >
        {t("admin.link.backToSignIn")}
      </button>
    </div>
  );
};
